import { DisplayFnArgumentsInfo } from '../../../models/template.model';
import { attributesOrder, LocaleKeys, ReportFieldsToSort } from './template-display-sort-order.const';

/**
 * Takes the array of arguments and sorts it based on the predefined order.
 *
 * This predefined order, usually comes from the blueprint configuration, but
 * could also be configured in the displayFn itself
 *
 * @param args arguments to order
 * @param displayFnArgumentsOrder Array that contains a list of IDs in the expected order to be formatted
 *
 * @see TemplateField.displayFnArgumentsOrder
 */
export function sortAttributesFields(args: DisplayFnArgumentsInfo[], displayFnArgumentsOrder: number[]) {
  let finalArguments: DisplayFnArgumentsInfo[] = [];
  if (displayFnArgumentsOrder != null && displayFnArgumentsOrder.length > 0) {
    const mapOfArguments = getArgumentsMap(args);
    const sortedDisplayArgs: DisplayFnArgumentsInfo[] = [];
    for (const id of displayFnArgumentsOrder) {
      const displayArgument = mapOfArguments[id];
      if (displayArgument != null) {
        sortedDisplayArgs.push(displayArgument);
      }
    }
    finalArguments = sortedDisplayArgs;
  }
  return finalArguments;
}

export function sortAttributesByFieldId(localeId: number, args: DisplayFnArgumentsInfo[], id: ReportFieldsToSort) {
  /*
   * Technical Debt
   * The reason for hot coded the position is the order coming from BE is not
   * consistent for different languages.
   * In future needs to change the framework side.
   */
  const requiredPositionOrder = getDisplayFnArgumentsOrderByFieldIdAndLocale(id, localeId);
  const finalArgs = [];
  requiredPositionOrder.forEach(order => {
    finalArgs.push(args[order]);
  });

  return finalArgs;
}

/**
 * Create a map of arguments based on its ID.
 */
function getArgumentsMap(displayArgs: DisplayFnArgumentsInfo[]): { [id: number]: DisplayFnArgumentsInfo } {
  const argumentsMap = {};
  for (const argument of displayArgs) {
    const { id } = argument;
    argumentsMap[id] = argument;
  }
  return argumentsMap;
}

function getDisplayFnArgumentsOrderByFieldIdAndLocale(id: number, localeId: LocaleKeys) {
  /*
   * Technical Debt
   * The reason for hot coded the position is the order coming from BE is not
   * consistent for different languages.
   * In future needs to change the framework side.
   */
  let displayFnArgumentsOrder: number[];
  switch (localeId) {
    case LocaleKeys.ChinaChinese: // Chinese
    case LocaleKeys.ChinaEnglish: // Chinese
    case LocaleKeys.UKEnglish: // UK English
    case LocaleKeys.IndiaEnglish: // India English
      displayFnArgumentsOrder = attributesOrder[id][localeId];
      break;
    default:
      // English
      displayFnArgumentsOrder = attributesOrder[id][LocaleKeys.USEnglish];
      break;
  }
  return displayFnArgumentsOrder;
}
